// extracted by mini-css-extract-plugin
export default {"headerContent":"History_headerContent__ZkpiV","layoutForm":"History_layoutForm__Lxj1n","inputForm":"History_inputForm__3Ra4P"};